import { BaseModel } from 'src/app/@shared/base.model';
import { FormMainType } from '@lib/types';
import { Role, User } from '@common/entities';
import { RoleModel } from 'src/app/role/@shared/role.model';

export type UserSource = User;

export class UserModel extends BaseModel<UserSource> {
  public email: string;
  public firstname: string;
  public lastname: string;
  public alias: string;
  public roles: RoleModel[];
  public notes: string;
  public type: FormMainType;

  constructor(source: UserSource) {
    super(source);

    this.title = this.getTitle(source);

    this.email = source.email;
    this.firstname = source.firstname;
    this.lastname = source.lastname;
    this.alias = source.alias;
    this.notes = source.notes;

    this.roles = this.getUserRoles(source.roles);

    this.type = 'user';
  }

  // eslint-disable-next-line class-methods-use-this
  private getTitle(source: UserSource): string {
    if (source.firstname && source.lastname) {
      return `${source.firstname} ${source.lastname}`;
    } else if (source.firstname) {
      return source.firstname;
    }

    return source.email;
  }

  // eslint-disable-next-line class-methods-use-this
  private getUserRoles(roles: Role[]): RoleModel[] {
    if (!roles) {
      return [];
    }

    return roles.map((role) => {
      return new RoleModel(role);
    });
  }
}
